import React, { Suspense, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation/";
import {
  MdLibraryBooks,
  MdSpaceDashboard,
  MdVerified,
  MdVideoLibrary,
} from "react-icons/md";
import { FaBell, FaChild, FaUsers } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { GiTeacher } from "react-icons/gi";

import { IoSettings, IoLogOut, IoChatbox } from "react-icons/io5";
import { TbDiscount2 } from "react-icons/tb";

import { auth, logout, onIdTokenChanged } from "../firebase";

import Header from "../components/Header";
import { LinearProgress } from "@mui/material";
import Toast from "../components/Toast";
import { AiFillCreditCard, AiOutlineLoading3Quarters } from "react-icons/ai";

import { ConfirmProvider } from "material-ui-confirm";
import { BsFillCartCheckFill, BsFillFlagFill } from "react-icons/bs";

import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";
import axios from "../config/axios";
import { useCallback } from "react";
import SuperSearch from "components/SuperSearch";

function Dashboard(props) {
  const [user, loading] = useAuthState(auth);
  const [isRefreshed, setRefresh] = useState({});
  const [customAuthState, setCustomAuthState] = useState({
    user: null,
    token: null,
  });

  const forceAppRefresh = () => {
    setRefresh({});
  };

  const navigate = useNavigate();

  const getToken = async () => {
    if (loading) {
      console.log("loading");
      return;
    }

    if (auth.currentUser) {
      const { claims } = await auth.currentUser.getIdTokenResult();
      if (claims.role == "Admin") {
        const unsubscribe = onIdTokenChanged(auth, async (user) => {
          if (user) {
            const { claims, token } = await user.getIdTokenResult();
            if (claims.role == "Admin") {
              setCustomAuthState({
                user: auth.currentUser,
                token,
              });
              console.log("User Logged in as Admin with " + user.email);
            } else {
              console.log("Logged Out because Not Admin");
              logout();
              unsubscribe();
              navigate("/login");
              return;
            }
          } else {
            console.log("Logged Out because No Login 1");
            unsubscribe();
            logout();
            navigate("/login");
            return;
          }
        });
      } else {
        console.log("Logged Out because not Admin");
        logout();
        navigate("/login");
      }
    } else {
      console.log("Logged Out because not Login 2");
      logout();
      navigate("/login");
    }
  };

  useEffect(() => {
    getToken();

    if (!auth.currentUser) return;

    const unsubClientId = axios.interceptors.request.use(async (request) => {
      request.headers = {
        ...request.headers,
        Authorization: `Bearer ${await auth.currentUser.getIdToken()}`,
      };
      return request;
    });

    return () => {
      // axios.interceptors.request.eject(unsubClientId); // Creating a bug for some reason
    };
  }, [auth.currentUser, loading, isRefreshed]);

  const menuData = [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: <MdSpaceDashboard size={20} />,
      keywords: ["stats", "statistics"],
      default: true,
    },

    {
      name: "Courses",
      url: "/dashboard/courses",
      icon: <MdVideoLibrary size={20} />,
    },

    {
      name: "Classes",
      url: "/dashboard/classes",
      icon: <SiGoogleclassroom size={20} />,
      keywords: ["Schedule", "batch"],
    },

    {
      name: "Coupons",
      url: "/dashboard/coupons",
      icon: <TbDiscount2 size={20} />,
      keywords: ["discount"],
    },

    {
      name: "Curriculum",
      url: "/dashboard/curriculum",
      icon: <MdLibraryBooks size={20} />,
      keywords: ["syllabus"],
    },

    {
      name: "Orders",
      url: "/dashboard/orders",
      icon: <BsFillCartCheckFill size={20} />,
    },

    {
      name: "Admin Chat",
      url: "/dashboard/chat",
      icon: <IoChatbox size={20} />,
      keywords: ["message"],
    },

    {
      name: "Mentors",
      url: "/dashboard/mentors",
      icon: <GiTeacher size={20} />,
      keywords: ["teachers"],
    },

    {
      name: "Mentees",
      url: "/dashboard/mentees",
      icon: <FaUsers size={20} />,
      keywords: ["users", "parents"],
    },
    {
      name: "Students",
      url: "/dashboard/students",
      icon: <FaChild size={20} />,
      keywords: ["children"],
    },

    {
      name: "Bookings",
      url: "/dashboard/counselling",
      icon: <FaChild size={20} />,
    },

    {
      name: "Payouts",
      url: "/dashboard/payouts",
      icon: <AiFillCreditCard size={20} />,
      keywords: ["money"],
    },

    {
      name: "Mentor Verification",
      url: "/dashboard/mentor-verification",
      icon: <MdVerified size={20} />,
      keywords: ["verified", "approve", "requests"],
    },

    {
      name: "Upcoming Interests",
      url: "/dashboard/upcoming-interests",
      icon: <FaBell size={20} />,
    },

    {
      name: "Notifications",
      url: "/dashboard/notifications",
      icon: <FaBell size={20} />,
      keywords: ["send", "email", "SMS", "Push"],
    },

    {
      name: "Reports",
      url: "/dashboard/reports",
      icon: <BsFillFlagFill size={20} />,
    },

    {
      name: "Others",
      url: "/dashboard/settings",
      icon: <IoSettings size={20} />,
      keywords: ["settings", "faqs", "template", "banners"],
    },

    {
      name: "Admin Notifications",
      url: "/dashboard/admin-notifications",
      icon: <FaBell size={20} />,
    },

    {
      name: "Logout",
      url: "/logout",
      icon: <IoLogOut size={20} />,
      keywords: ["bye", "tata"],
    },

    // Hidden Fields
    {
      name: "Create New Course",
      url: "/dashboard/courses/edit",
      keywords: ["NCOURSE"],
      hidden: true,
    },

    {
      name: "Create New Curriculum",
      url: "/dashboard/curriculum/edit",
      hidden: true,
      keywords: ["NCURRICULUM"],
    },
  ];

  const location = useLocation();

  const [activeMenuItem, setActiveMenuItem] = useState(0);

  const [canfettiState, setCanfettiState] = useState(0);

  // run canfetti for given duration
  const runCanfetti = (duration = 5000) => {
    setCanfettiState(500);
    setTimeout(() => {
      setCanfettiState(0);
    }, duration);
  };

  const [nav, setNav] = useState(!isMobile);
  const [progress, setProgress] = useState(false);
  const [toast, setToast] = useState({
    error: false,
    success: false,
    message: false,
    autohide: 3000,
  });

  const navigationHandler = (item) => {
    navigate(item.url);
  };

  useEffect(() => {
    setActiveMenuItem(
      menuData.findIndex((item) => {
        if (item.url == "/dashboard") {
          return location.pathname == item.url;
        }
        return location.pathname.includes(item.url);
      })
    );
  }, [location]);

  useEffect(() => {
    window.addEventListener("keydown", (ev) => {
      if (ev.key === "r" && (ev.ctrlKey || ev.metaKey)) {
        ev.preventDefault(); // Prevent browser reload on CTRL+R

        const asyncFunction = async () => {
          getToken();
          forceAppRefresh();
        };
        asyncFunction();
      }
    });
  }, []);
  const { width, height } = useWindowSize();

  return (
    <div>
      <div
        className={
          "w-screen flex items-center justify-center text-small text-gray-800 gap-4 transition-all duration-1000 " +
          (loading ? "h-screen" : "invisible h-0 opacity-0")
        }
      >
        Loading Admin Panel
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
      {/* {console.log(user && user.uid)} */}
      {customAuthState.user && (
        <div className="flex flex-row justify-evenly h-screen bg-offwhite w-screen">
          <Navigation
            nav={nav}
            setNav={setNav}
            onSelect={navigationHandler}
            menu={menuData.filter((item) => !item.hidden)}
            active={activeMenuItem}
            setActive={setActiveMenuItem}
            className="sm:w-[15vw]"
          />
          <div className=" pb-0 flex flex-col sm:w-[85vw] w-full">
            <Header
              setNav={setNav}
              name={
                activeMenuItem != -1
                  ? menuData[activeMenuItem].name
                  : "Dashboard"
              }
              onForceRefresh={forceAppRefresh}
              isLoading={progress}
              onMenuClick={() => setNav(true)}
            />
            <div
              className={
                `absolute inset-0 bg-black opacity-50 h-full flex flex-col transition-all z-40 ` +
                (nav && isMobile ? "visible" : "invisible")
              }
              onClick={() => setNav(false)}
            ></div>
            <div className="bg-white shadow-md rounded-md flex-grow bg-blend-darken sm:overflow-scroll scroll-smooth">
              {progress && <LinearProgress />}
              <div className="py-4 px-6 overflow-scroll">
                <ConfirmProvider>
                  <Suspense fallback={<div></div>}>
                    <Outlet
                      context={{
                        setProgress,
                        isLoading: progress,
                        setToast,
                        isRefreshed,
                        runCanfetti,
                      }}
                    />
                  </Suspense>
                </ConfirmProvider>
                {
                  <Confetti
                    width={width}
                    height={height}
                    numberOfPieces={canfettiState}
                  />
                }
              </div>

              <Toast
                success={toast.success}
                error={toast.error}
                message={toast.message}
                autoHide={toast.autohide}
                onClose={() => {
                  setToast({ ...toast, error: false, success: false });
                }}
              />
              <SuperSearch defaultIndex={menuData} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
